module.exports = __webpack_public_path__ + "static/media/card_synergia.98e8736c.png";